import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';

export default class ToggleNavItemPin {
  constructor(context) {
    this.context = context;
  }

  run({ id }) {
    const preferences = this.context.stores.agentPreferences.get();
    preferences.toggleNavItemPin(id);
    setAgentPreferences(this.context, preferences);
  }
}
